export default defineNuxtRouteMiddleware(async (to) => {
  const { $i18n } = useNuxtApp();

  if (!to.query.idAccountSearch || !/^[0-9]+$/.test(to.query.idAccountSearch as string)) {
    return await navigateTo(`/${$i18n.locale.value}`, { redirectCode: 301 });
  }
});
